"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var uuid_1 = require("uuid");
exports.default = vue_1.default.extend({
    props: {
        initValue: {
            type: String,
            default: ""
        },
        id: {
            type: String,
            default: uuid_1.v4()
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            name: "role-name-input",
            value: this.initValue
        };
    },
    watch: {
        initValue: function () {
            this.value = this.initValue;
        }
    },
    methods: {
        isValid: function (emitValidation) {
            if (emitValidation === void 0) { emitValidation = false; }
            if (!!this.value.trim()) {
                return true;
            }
            if (emitValidation) {
                this.$emit("invalid");
            }
        },
        updateValue: function (value) {
            this.value = value;
            this.$emit("input", value);
        },
        onBlur: function () {
            this.appendValidationClass();
        },
        appendValidationClass: function () {
            var ref = this.$refs.roleName;
            if (!ref || !ref.classList) {
                return;
            }
            if (this.isValid()) {
                ref.classList.remove("is-invalid");
                ref.classList.add("is-valid");
            }
            else {
                ref.classList.remove("is-valid");
                ref.classList.add("is-invalid");
            }
        }
    }
});
